<template>
  <div class="app-page--gray pb-10">
    <slot/>
    <br>
    <br class="hidden md:block">
    <br class="hidden md:block">
    <page-box>
      <section class="bg-white relative w-full rounded-xl p-6">
        <NuxtPage />
      </section>
    </page-box>
  </div>
</template>
